import Lenis from "lenis";

// Inertial smooth scroll. Skipped entirely for reduced-motion users — native
// scrolling plus the CSS `scroll-behavior` fallback takes over.
export function initSmoothScroll(): Lenis | null {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return null;
  const lenis = new Lenis({ lerp: 0.12, anchors: true });
  const raf = (time: number) => {
    lenis.raf(time);
    requestAnimationFrame(raf);
  };
  requestAnimationFrame(raf);
  return lenis;
}
